import React from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import DialogQuestLayout from '../../../../components/DialogQuestLayout';
import Popup from '../../../../components/Popup';
import UxHelpers from '../../../../helpers/ux-helpers';
import Dialog from '../../index';

const DeleteAccountRequestUnsubscribeDialog = (props) => {
  const { show, proceed, dismiss } = props;

  const onSuccess = (data) => {
    proceed(data);
    UxHelpers.overflowLock('unlock');
  };

  const body = (
    <Dialog dialogStyles={{ width: 600, marginBottom: '-20px' }} dialogCssClass={'delete-account-dialog'}>
      <DialogQuestLayout
        message="Your profile is no longer visible on the platform.  Do you want to still receive email alerts about jobs?"
        cases={[
          {
            title: 'No, unsubscribe',
            action: () => {
              onSuccess(true)
            },
            buttonText: 'Unsubscribe from all emails',
          }, {
            title: 'Yes, keep me subscribed',
            action: () => {
              onSuccess(false)
            },
            buttonText: 'Visit notifications page to adjust preferences',
          }
        ]}
      />
    </Dialog>
  );

  return (
    show && (
      <Popup
        actions={{ dismiss }}
        bodyRender={body}
      />
    )
  );
};

export default createConfirmation(confirmable(DeleteAccountRequestUnsubscribeDialog));
